/* ============================================================
   c_express-checkout.js — PDP のエクスプレスチェックアウト
   ────────────────────────────────────────────────────────────
   受注品は、納期の確認にチェックするまでエクスプレスチェックアウトの
   ボタン（Shopify の payment_button）を押せなくする。

   ボタンは iframe / Web Component の中に描かれ、外から click を
   捕まえて止めることができない。そこでボタンの入れ物を inert にして
   クリックもキーボード操作も止め、クリックは外側の枠
   （[data-c-express-frame]）で受けて確認を促す。
   inert の要素はクリックの当たり判定から外れるため、
   押した位置の下にある外側の枠に click が届く。

   汎用の「Buy it now」ボタン（使えるウォレットが無いときに出る）の文言は、
   Add to Cart と同じく全言語で英語にそろえる。Shopify はロケールに合わせて
   「今すぐ購入」「立即購買」に訳して描き、描き直すこともあるので、
   MutationObserver で見張って [data-c-express-label] の文言に差し替える。
   MutationObserver のコールバックは描画より前に走るので、訳文は画面に出ない。
   ウォレット（Shop Pay 等）のボタンは文言を持たないので対象外。

   マークアップは sections/c_main-product.liquid。
   上限到達時に枠ごと隠すのは c_quantity-stepper.js。
   ============================================================ */
(function () {
  'use strict';

  if (window.__cExpressInit) return;
  window.__cExpressInit = true;

  var LOCKED = 'is-locked';

  function parts(root) {
    return {
      ack: root.querySelector('[data-c-express-ack]'),
      frame: root.querySelector('[data-c-express-frame]'),
      buttons: root.querySelector('[data-c-express-buttons]'),
      msg: root.querySelector('[data-c-express-msg]'),
      live: root.querySelector('[data-c-express-live]')
    };
  }

  // 同じ文言を入れ直しても読まれないため、一度空にしてから入れる
  function announce(live, text) {
    if (!live || !text) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 50);
  }

  function sync(root) {
    var p = parts(root);
    // 確認チェックが無い（在庫品）ならロックしない
    if (!p.ack || !p.frame || !p.buttons) return;
    var locked = !p.ack.checked;
    p.frame.classList.toggle(LOCKED, locked);
    p.buttons.inert = locked;
    if (!locked && p.msg) p.msg.hidden = true;
  }

  function syncAll() {
    document.querySelectorAll('[data-c-express]').forEach(sync);
  }

  function onChange(e) {
    var ack = e.target.closest && e.target.closest('[data-c-express-ack]');
    if (!ack) return;
    var root = ack.closest('[data-c-express]');
    if (root) sync(root);
  }

  function onFrameClick(e) {
    var frame = e.target.closest && e.target.closest('[data-c-express-frame]');
    if (!frame || !frame.classList.contains(LOCKED)) return;
    var root = frame.closest('[data-c-express]');
    if (!root) return;
    var p = parts(root);
    if (p.msg) {
      p.msg.hidden = false;
      announce(p.live, (p.msg.textContent || '').trim());
    }
    if (p.ack) p.ack.focus();
  }

  /* ── 「Buy it now」の文言 ─────────────────────────────── */

  var UNBRANDED = '.shopify-payment-button__button--unbranded';

  function applyLabel(root) {
    var label = root.getAttribute('data-c-express-label');
    if (!label) return;
    root.querySelectorAll(UNBRANDED).forEach(function (btn) {
      // 差し替え自体も変化として通知されるので、同じなら触らない（無限ループ防止）
      if (btn.textContent.trim() !== label) btn.textContent = label;
    });
  }

  function watchLabel(root) {
    applyLabel(root);
    if (typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      applyLabel(root);
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    document.querySelectorAll('[data-c-express]').forEach(watchLabel);
    syncAll();
    document.addEventListener('change', onChange);
    document.addEventListener('click', onFrameClick);
    // bfcache から戻ったときは、チェックの状態がそのまま残っている
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) syncAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
